import { useEffect } from "react";
import PropTypes from "prop-types";

const HotjarEmbed = ({ criticalConfig }) => {
  const { hotjar_id, hotjar_enabled, hotjar_version = 6 } = criticalConfig;

  useEffect(() => {
    if (!hotjar_enabled || !hotjar_id) return;
    if (window.hj) return;

    (function (h, o, t, j, a, r) {
      h.hj =
        h.hj ||
        function (...args) {
          (h.hj.q = h.hj.q || []).push(args);
        };
      h._hjSettings = { hjid: hotjar_id, hjsv: hotjar_version };
      a = o.getElementsByTagName("head")[0];
      r = o.createElement("script");
      r.async = true;
      r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
      a.appendChild(r);
    })(window, document, "https://static.hotjar.com/c/hotjar-", ".js?sv=");
  }, [hotjar_enabled, hotjar_id, hotjar_version]);

  return null;
};

HotjarEmbed.propTypes = {
  criticalConfig: PropTypes.shape({
    hotjar_id: PropTypes.number,
    hotjar_enabled: PropTypes.bool,
    hotjar_version: PropTypes.number
  }).isRequired
};

export default HotjarEmbed;
